import { getTripCargoCollectionRef, getTripCargoDocRef } from "../paths";
import { BaseFirestoreRepository } from "./BaseFirestoreRepository";

export class FirestoreTripCargoRepository extends BaseFirestoreRepository {
  async upsertEntity(entity, scope) {
    return this.upsert(
      getTripCargoDocRef(this.db, entity.id),
      this.addStorageMarker({
        ...entity,
        organizationId: scope.organizationId,
        vesselId: scope.vesselId,
        voyageId: scope.voyageId,
      })
    );
  }

  async deleteEntity(entityId) {
    return this.delete(getTripCargoDocRef(this.db, entityId));
  }

  async listByTripId(tripId) {
    return this.listByField(getTripCargoCollectionRef(this.db), "tripId", tripId);
  }

  async getEntity(cargoId) {
    const entity = await this.get(getTripCargoDocRef(this.db, cargoId));
    return this.isManagedV2Document(entity) ? entity : null;
  }
}
